import { Radius } from './Border';
import * as BaseColor from './Color';
import * as BaseSizes from './Size';

export enum SelectSize {
  XSmall = 155,
  Small = 180,
  Medium = 220,
  Large = 280,
}

export enum DropdownSize {
  Small = 180,
  Medium = 220,
  Large = 280,
}

export enum CheckboxSize {
  Small = BaseSizes.Large,
  Medium = BaseSizes.XLarge,
  Large = BaseSizes.X3Large,
}

export enum RadioSize {
  Small = BaseSizes.Large,
  Medium = BaseSizes.XLarge,
  Large = BaseSizes.X3Large,
}

export const InputSize = {
  Small: { width: BaseSizes.X8Large, height: BaseSizes.X2Large },
  Medium: { width: 288, height: 38 },
};

export const Input = {
  Radius: Radius.Small,
  Placeholder: {
    Color: BaseColor.Neutrals.Gray,
  },
  Size: 'Body',
  Number: {
    Radius: Radius.XSmall,
  },
};

export const FontSize = {
  Small: BaseSizes.Medium,
};

export const Switch = {
  Color: BaseColor.System.Primary,
  Size: {
    Medium: {
      width: BaseSizes.X5Large,
      height: BaseSizes.XLarge,
      handleSize: 14,
      trackPadding: 3,
      transitionDistance: BaseSizes.Large,
    },
    Small: {
      width: BaseSizes.X3Large,
      height: BaseSizes.Large,
      handleSize: BaseSizes.Medium,
      trackPadding: BaseSizes.X3Small,
      transitionDistance: BaseSizes.Medium,
    },
  },
  Opacity: {
    Disabled: 0.65,
  },
};

export const InputNumberControllers = {
  Small: { width: BaseSizes.X2Large },
};

export const InputAddons = {
  width: BaseSizes.X5Large,
};

export const Slider = {
  thumb: {
    size: BaseSizes.Large,
    border: {
      width: 3,
      color: BaseColor.Brand.Light,
    },
    shadow: 'none',
  },
  track: {
    height: BaseSizes.XSmall,
  },
};

export const TextArea = {
  Radius: Radius.Medium,
};

export const Checkbox = {
  Color: {
    Background: BaseColor.Overlay.Light,
  },
};
